import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
export class MillstoneUtilities extends AbstractTagClass {
    constructor(argument) {
        super({
            name: 'MillstoneUtilities',
            ...argument
        });
    }
    getMillstoneMetadata(params = this.tag?.params) {
        return params?.CONTENT?.millstone;
    }
    getStreamingUrl(params = this.tag?.params) {
        return this.getMillstoneMetadata(params)?.streamingUrl;
    }
    getDaiParams(params = this.tag?.params) {
        return this.getMillstoneMetadata(params)?.daiParams;
    }
    getDaiCmsId(params = this.tag?.params) {
        return this.getDaiParams(params)?.daiCmsId;
    }
}
